export const SELECTED_VARIATIONMS=`SELECTED_VARIATIONMS`;
export const SELECTED_DEPARTUREMS=`SELECTED_DEPARTUREMS`;
export const SELECTED_VARIATIONMS_DEPARTUREMS=`SELECTED_VARIATIONMS_DEPARTUREMS`;